import { render, staticRenderFns } from "./AuthGoogle.vue?vue&type=template&id=19af5f88&scoped=true&"
import script from "./AuthGoogle.vue?vue&type=script&lang=js&"
export * from "./AuthGoogle.vue?vue&type=script&lang=js&"
import style0 from "./AuthGoogle.vue?vue&type=style&index=0&id=19af5f88&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19af5f88",
  null
  
)

export default component.exports